import AbsComponent from "./AbsComponent"
import Templ from './HotkeywordTempl';

/**
 * Hotkeyword class
 * @category Hotkeyword
 * @param  {Object} _store={} 핫키워드 리스트
 * @param  {String} _el='' 셀렉터
 * @param  {String} _motionType='bottom' 레이어 등장 기준 bottom/top
 * @example
 * new Hotkeyword( window.live_keywords.item, '#container .hotkeyword', 'bottom');
 */
class Hotkeyword extends AbsComponent{
    constructor(_store={}, _el='', _motionType='bottom'){
        super(_store, _el);

        this.newNum = 0;
        this.itemLength = 0;
        this.oldItem = null;
        this.newItem = null;

        this.render(this.store);
        this.setting();
        this.addEvents(_motionType);
    }

    render(_jsonData = {}){
        this.itemLength = _jsonData[0].list.length-1;
        $(this.el).append( Templ.getTempl(_jsonData) );
    }

    setting(){
        if(this.oldItem) TweenMax.to( this.oldItem, 1, {y:'-200%'} );
        this.newItem = `${this.el} .is-rolling li[data-idx=${this.newNum}]`;
        TweenMax.fromTo(this.newItem, 1, {y: '0%'}, {y: '-100%'});
        
        this.oldItem = this.newItem;
        this.newNum = ( this.newNum >= this.itemLength)? 0: this.newNum+1;

        setTimeout(() => this.setting(), 5000);
    }

    addEvents(_motionType){
        $(`${this.el} .hotkeyword-toggle`).on('click', ()=>{
            $(this.el).toggleClass('is-active');
            let startObj = (_motionType ==='bottom')? {y:'100%', opacity:1}: {y:'10%', opacity:0};

            TweenMax.fromTo(this.el + ' .is-layer', 0.30, startObj, {y:'0%', opacity:1, ease: Power3.easeOut});
        });

        $('body').on('click', (e)=>{
            if( $(e.target).closest('.hotkeyword-toggle').length < 1 ){
                $(this.el).removeClass('is-active');
            }
        });
    }

} // end of class
export default Hotkeyword;